import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M8 6h.01","key":"svg-1"}],["path",{"d":"M16 18h.01","key":"svg-2"}],["path",{"d":"M10 15h3a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-3v-3h4","key":"svg-3"}]]

const IconPlayCard5 = createReactComponent('outline', 'play-card-5', 'PlayCard5', __iconNode);

export default IconPlayCard5;